import {Injectable} from "@angular/core";
import {GenericFilterService} from "./generic-filter.service";
import {Product} from "../../models/product";

@Injectable({providedIn: 'root'})
export class DoorsuppliesonlineFilterService extends GenericFilterService {

  override setReferralDoor(door: Product | undefined) {
    if (!door) {
      return
    }

    if (!this.isReferralAlreadySet) {
      // On referal traffic we wanna filter for the same finish tag
      // We stored the finish tag in the custom data on the backed
      const customData = door.customData && JSON.parse(door.customData)

      const finishTags = customData?.finishTags as Array<string>

      super.setFilter({
        categories: [{
          id: 'finish', enabled: true, name: 'Finish', show: true, options: finishTags.map((tag) => {
            return {
              id: tag,
              description: tag, selected: true
            }
          })
        }]
      });

      this.isReferralAlreadySet = true;
    }

    super.setReferralDoor(door);
  }
}
